export default {
  imageId: 'woman-globe',
  title: 'Willkommen!',
  text: 'Bei der Bürgerkonferenz diskutieren Sie – Menschen aus ganz Deutschland – verschiedene Möglichkeiten, wie Deutschland seine Energieversorgung klimafreundlich gestalten kann.',
  button: 'Starten'
}
